import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';
// Defined outside AreaDropdown so it keeps a stable identity across
// re-renders — see BreedDropdown's Option for why nesting it inside the
// component causes a full unmount/remount of the <option> list (and a
// silently discarded selection) on every unrelated re-render.
const Option = (props) => {
  if (props.selected === props.value) {
    return <option value={props.value}
                   selected="selected">{props.name}</option>
  }
  return <option value={props.value}>{props.name}</option>
}

export const AreaDropdown = (props) => {
  const { t } = useTranslation();
  const [areas, setAreaData] = useState([]);
  useEffect(() => {
    if (props.areas != null) {
      setAreaData(props.areas);
      return;
    }
    Fetch("api/data/areas", "get", null,
      (data) => {
        setAreaData(data);
      },
      () => {console.log("error loading areas")}
    );
  }, [props.areas]);

  // Only coerce a missing selected to "" when an onChange is actually
  // supplied. Bare-form usages (AddBirth, AddRain, AddTemperature) pass
  // neither — this <select> is meant to be uncontrolled there, read back via
  // FormData at submit. Unconditionally defaulting to "" previously made
  // React treat those as controlled with a value permanently pinned to ""
  // and no onChange to ever update it — a classic React footgun where the
  // field can't be changed at all, since React resets the DOM back to the
  // controlled value on every interaction. Controlled callers (filters,
  // inline edits) always pass onChange, sometimes with selected briefly
  // undefined (e.g. a row with no area yet) — for those we keep defaulting
  // to "" so the field doesn't flip between controlled and uncontrolled.
  const value = props.onChange ? (props.selected || "") : props.selected;

  return (
    <select name="area" onChange={props.onChange}
            style={props.style} value={value}>
      {props.showAll &&
       <option value="">{t("all_areas")}</option>
      }
      {props.showUnknown &&
        <option value="unknown">{t("unknown")}</option>
      }
      {areas.map((area) => (
        <Option key={area.name}
          value={area.name}
          name={area.name.charAt(0).toUpperCase() + area.name.slice(1)}
          selected={props.selected}
        />
      ))}
    </select>
  );
}
export default AreaDropdown;
